import {
  ContentBlock,
  ContentBlockBody,
  ContentBlockGroup,
} from "shared/components/content/ContentBlock";
import { PageTabBody } from "shared/components/layout/PageTabBody";

export const CommitmentSetupTabLetter: React.FC = () => (
  <PageTabBody>
    <ContentBlockGroup>
      <ContentBlock>
        <ContentBlockBody>TODO: Side Letter Details</ContentBlockBody>
      </ContentBlock>
    </ContentBlockGroup>
  </PageTabBody>
);
